@if (showCustomAccessUi) {
<!-- Access Denied -->
@if (!hasAccess && !isLoadingAccess) {
  <div
    class="d-flex flex-column align-items-center justify-content-center text-center p-4 text-muted"
    style="min-height: 150px;">
    <mat-icon class="material-symbols-outlined" style="font-size: 36px; width: 36px; height: 36px; opacity: 0.5;">lock_outline</mat-icon>
    <h5 class="mt-3 fw-semibold">Access Denied</h5>
    <p class="small">You do not have permission to view or manage access control for this service.</p>
  </div>
}

@if (hasAccess || isLoadingAccess) {
  @if (isLoadingAccess) {
    <div class="access-skeleton access-skeleton--card mb-3">
      <div class="access-control-card access-skeleton-card mb-3">
        <div class="card-info access-skeleton-copy">
          <ngx-skeleton-loader animation="progress" loadingText="Loading access control"
            [theme]="{ width: '170px', height: '18px', 'border-radius': '8px', 'margin-bottom': '0' }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"
            [theme]="{ width: '310px', height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
          </ngx-skeleton-loader>
        </div>
        <ngx-skeleton-loader animation="progress" appearance="circle"
          [theme]="{ width: '38px', height: '38px', margin: '0' }">
        </ngx-skeleton-loader>
      </div>
      <div
        class="owner-card access-skeleton-owner d-flex align-items-center justify-content-between p-3 mb-3 border rounded">
        <div class="d-flex align-items-center gap-3">
          <ngx-skeleton-loader animation="progress" appearance="circle"
            [theme]="{ width: '48px', height: '48px', margin: '0' }">
          </ngx-skeleton-loader>
          <div class="access-skeleton-copy">
            <ngx-skeleton-loader animation="progress"
              [theme]="{ width: '148px', height: '14px', 'border-radius': '8px', 'margin-bottom': '0' }">
            </ngx-skeleton-loader>
            <ngx-skeleton-loader animation="progress"
              [theme]="{ width: '96px', height: '10px', 'border-radius': '8px', 'margin-bottom': '0' }">
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="access-skeleton-copy access-skeleton-copy--align-end">
          <ngx-skeleton-loader animation="progress"
            [theme]="{ width: '68px', height: '14px', 'border-radius': '8px', 'margin-bottom': '0' }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress"
            [theme]="{ width: '80px', height: '10px', 'border-radius': '8px', 'margin-bottom': '0' }">
          </ngx-skeleton-loader>
        </div>
      </div>
      <div class="access-skeleton-toolbar d-flex mb-2">
        <div class="access-section-header flex-grow-1 access-skeleton-tabs">
          <div class="d-flex align-items-center tab-row">
            <div class="d-flex flex-grow-1 access-skeleton-tab-row">
              <ngx-skeleton-loader animation="progress"
                [theme]="{ width: '76px', height: '14px', 'border-radius': '8px', 'margin-bottom': '0' }">
              </ngx-skeleton-loader>
              <ngx-skeleton-loader animation="progress"
                [theme]="{ width: '84px', height: '14px', 'border-radius': '8px', 'margin-bottom': '0' }">
              </ngx-skeleton-loader>
            </div>
          </div>
          <div class="d-flex align-items-center tab-row">
            <div class="d-flex flex-grow-1 access-skeleton-tab-row">
              <ngx-skeleton-loader animation="progress"
                [theme]="{ width: '68px', height: '14px', 'border-radius': '8px', 'margin-bottom': '0' }">
              </ngx-skeleton-loader>
              <ngx-skeleton-loader animation="progress"
                [theme]="{ width: '72px', height: '14px', 'border-radius': '8px', 'margin-bottom': '0' }">
              </ngx-skeleton-loader>
            </div>
          </div>
        </div>
        <div class="access-skeleton-actions d-flex flex-column ms-1">
          <ngx-skeleton-loader animation="progress" appearance="circle"
            [theme]="{ width: '32px', height: '32px', margin: '4px 0 0' }">
          </ngx-skeleton-loader>
          <ngx-skeleton-loader animation="progress" appearance="circle"
            [theme]="{ width: '32px', height: '32px', margin: '10px 0 0' }">
          </ngx-skeleton-loader>
        </div>
      </div>
      <div class="access-skeleton-summary px-2 pb-2">
        <ngx-skeleton-loader animation="progress"
          [theme]="{ width: '240px', height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
        </ngx-skeleton-loader>
      </div>
      <div class="access-entries-list access-skeleton-entries">
        @for (width of accessEntrySkeletonWidths; track width) {
          <div class="access-entry d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
            >
            <div class="entry-left w-100 d-flex align-items-center gap-3">
              <ngx-skeleton-loader animation="progress" appearance="circle"
                [theme]="{ width: '24px', height: '24px', margin: '0' }">
              </ngx-skeleton-loader>
              <div class="access-skeleton-copy flex-grow-1">
                <ngx-skeleton-loader animation="progress"
                  [theme]="{ width: width, height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
                </ngx-skeleton-loader>
                <ngx-skeleton-loader animation="progress"
                  [theme]="{ width: '92px', height: '10px', 'border-radius': '8px', 'margin-bottom': '0' }">
                </ngx-skeleton-loader>
              </div>
            </div>
            <ngx-skeleton-loader animation="progress" appearance="circle"
              [theme]="{ width: '28px', height: '28px', margin: '0' }">
            </ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
  } @else {
    <div>
      <div class="access-control-card mb-3">
        <div class="card-info">
          <span class="card-title">Custom Access</span>
          <span class="card-description text-muted">Enable to specify which users and groups can manage this
          service</span>
        </div>
        <mat-slide-toggle [(ngModel)]="accessForm.enabled" (ngModelChange)="onAccessControlToggle($event)"
          (keydown.enter)="onAccessControlToggleEnter($event)"
          color="primary" [disabled]="!canModifyAccess || readonly" [ngModelOptions]="{standalone: true}">
        </mat-slide-toggle>
      </div>
      <div class="mt-1">
        <!-- Owner Badge Block -->
        @if (ownerEntry) {
          <div class="owner-card d-flex align-items-center justify-content-between p-3 mb-3 border rounded"
            >
            <div class="d-flex align-items-center gap-3">
              <div class="owner-icon-wrapper owner-avatar-chip rounded-circle d-flex align-items-center justify-content-center">
                <mat-icon class="material-symbols-outlined owner-avatar-icon">workspace_premium</mat-icon>
              </div>
              <div class="lh-sm">
                <div class="fw-bold" style="font-size: 14px; color: #181c32; margin-bottom: 2px;">{{
                ownerEntry.name }}</div>
                @if (accessForm.enabled && !isTransferringOwnership && canModifyAccess && !readonly && eligibleNewOwners.length > 0) {
                  <button class="transfer-btn-inline mt-1" type="button" (click)="toggleOwnershipTransfer()"
                    >
                    Switch Owner
                  </button>
                }
              </div>
            </div>
            <div class="lh-sm text-end">
              <div class="fw-bold mb-1" style="font-size: 14px; color: #181c32;">Owner</div>
              <div class="text-muted" style="font-size: 12px;">Full control</div>
            </div>
          </div>
        }
        <!-- Ownership Transfer Panel -->
        @if (accessForm.enabled && isTransferringOwnership) {
          <div class="ownership-transfer-wrapper p-3 border rounded mb-3">
            <div class="fw-bold mb-2 pb-2 border-bottom" style="font-size: 14px;">Select New Owner
            </div>
            <div class="text-muted small mb-3">Only users with 'Edit' permission can be made the new owner.</div>
            <div class="search-bar px-2 py-2 border border-bottom-0 rounded-top d-flex align-items-center">
              <mat-icon class="text-muted me-2 material-symbols-outlined" style="font-size:17px;width:17px;height:17px;">search</mat-icon>
              <input type="text" class="form-control border-0 shadow-none p-0 bg-transparent"
                placeholder="Search owner" [(ngModel)]="searchQueryTransfer"
                [ngModelOptions]="{standalone: true}">
              </div>
              <div class="eligible-users-list border border-top-0 rounded-bottom"
                style="max-height: 250px; overflow-y: auto; padding: 16px 20px;">
                <mat-radio-group [(ngModel)]="selectedNewOwnerId" [ngModelOptions]="{standalone: true}"
                  class="d-flex flex-column gap-2">
                  @for (user of filteredEligibleNewOwners; track trackByEligibleOwnerId($index, user)) {
                    <div
                      class="transfer-user-row d-flex align-items-center"
                      [class.selected]="selectedNewOwnerId === user.id" (click)="selectedNewOwnerId = user.id">
                      <mat-radio-button [value]="user.id" color="primary"
                        (keydown.enter)="onTransferOwnerEnter($event, user.id)"
                        class="h-100 d-flex align-items-center m-0">
                        <span class="small" style="display: block;">{{ user.name }}</span>
                      </mat-radio-button>
                    </div>
                  }
                </mat-radio-group>
                @if (filteredEligibleNewOwners.length === 0) {
                  <div class="text-muted small py-4 text-center">
                    @if (searchQueryTransfer) {
                      No users found.
                    } @else {
                      No eligible users found. Please grant Edit access to a user first.
                    }
                  </div>
                }
              </div>
              <div class="d-flex justify-content-end gap-2 mt-4">
                <button type="button" mat-button class="fw-semibold cancel-transfer-btn"
                (click)="cancelOwnershipTransfer()">CANCEL</button>
                <button type="button" mat-raised-button color="primary" class="submit-transfer-btn"
                  [disabled]="!selectedNewOwnerId" (click)="confirmOwnershipTransfer()">
                  SWITCH OWNER
                </button>
              </div>
            </div>
          }
          <!-- Management UI: Only visible when Custom Access is enabled -->
          @if (accessForm.enabled) {
            <!-- Combined Tabs Container and Floating Icons -->
            <div class="d-flex mb-2">
              <!-- Tab Box -->
              <div class="access-section-header flex-grow-1">
                <!-- Users / Groups row -->
                <div class="d-flex align-items-center tab-row">
                  <div class="d-flex flex-grow-1">
                    <button type="button" class="access-tab-btn"
                      [class.active]="activeAccessTab === 'users'" (click)="switchEntityTab('users')">
                      Users
                    </button>
                    <button type="button" class="access-tab-btn"
                      [class.active]="activeAccessTab === 'groups'" (click)="switchEntityTab('groups')">
                      Groups
                    </button>
                  </div>
                </div>
                <!-- Edit / View row -->
                @if (hasActiveNonOwnerEntries || isEditingAccess) {
                  <div class="d-flex align-items-center tab-row position-relative"
                    >
                    <div class="d-flex flex-grow-1">
                      <button type="button" class="access-tab-btn"
                        [class.active]="activePermissionTab === 'edit'"
                        (click)="switchPermissionTab('edit')">
                        Edit
                      </button>
                      <button type="button" class="access-tab-btn"
                        [class.active]="activePermissionTab === 'view'"
                        (click)="switchPermissionTab('view')">
                        View
                      </button>
                    </div>
                  </div>
                }
              </div>
              <!-- Floating action icons -->
              <div class="d-flex flex-column ms-1" style="width: 40px; padding-left: 2px;">
                <!-- Add -->
                <div class="d-flex align-items-center justify-content-center"
                  style="height: 40px; margin-bottom: 2px;">
                  @if (canModifyAccess && !readonly) {
                    <button mat-icon-button type="button" class="action-toggle-btn"
                      [class.is-open]="isEditingAccess"
                      [matTooltip]="isEditingAccess ? 'Close' : 'Add ' + (activeAccessTab === 'users' ? 'users' : 'groups')"
                      (click)="toggleAddPanel()">
                      <mat-icon class="material-symbols-outlined">{{ isEditingAccess ? 'close' : 'person_add' }}</mat-icon>
                    </button>
                  }
                </div>
                <!-- Edit entries -->
                @if (hasActiveNonOwnerEntries || isEditingAccess) {
                  <div class="d-flex align-items-center justify-content-center" style="height: 40px;"
                    >
                    @if (canModifyAccess && !readonly && filteredEntries.length > 0) {
                      <button mat-icon-button type="button" class="action-toggle-btn"
                        (click)="isEditingEntries = !isEditingEntries" [class.text-primary]="isEditingEntries"
                        [matTooltip]="isEditingEntries ? 'Cancel Edit' : 'Edit Entries'">
                        <mat-icon class="material-symbols-outlined" style="font-size: 18px; width: 18px; height: 18px;">{{ isEditingEntries ?
                          'close'
                        : 'edit' }}</mat-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
            <!-- Collapsible Add Panel -->
            @if (canModifyAccess && isEditingAccess) {
              <div class="add-panel mb-2 pb-2">
                <!-- Search -->
                <div class="search-bar px-2 py-2 border-bottom d-flex align-items-center">
                  <mat-icon class="text-muted me-2 material-symbols-outlined"
                  style="font-size:17px;width:17px;height:17px;">search</mat-icon>
                  <input type="text" class="form-control border-0 shadow-none p-0"
                    [placeholder]="activeAccessTab === 'users' ? 'Search users...' : 'Search groups...'"
                    [ngModel]="activeAccessTab === 'users' ? searchQueryUsers : searchQueryGroups"
                    (ngModelChange)="activeAccessTab === 'users' ? onSearchUsers($event) : onSearchGroups($event)"
                    [ngModelOptions]="{standalone: true}">
                  </div>
                  @if (isLoadingEntities) {
                    <div class="add-panel-skeleton">
                      <div class="search-bar px-2 py-2 border-bottom d-flex align-items-center">
                        <ngx-skeleton-loader animation="progress" appearance="circle"
                          [theme]="{ width: '16px', height: '16px', margin: '0 8px 0 0' }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader animation="progress"
                          [theme]="{ width: '36%', height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
                        </ngx-skeleton-loader>
                      </div>
                      <div class="px-2 py-2 border-bottom d-flex align-items-center select-all-row">
                        <ngx-skeleton-loader animation="progress" appearance="circle"
                          [theme]="{ width: '18px', height: '18px', margin: '0 8px 0 0' }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader animation="progress"
                          [theme]="{ width: '82px', height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
                        </ngx-skeleton-loader>
                      </div>
                      <div class="entity-list overflow-auto add-panel-skeleton-list" style="max-height: 180px;">
                        @for (width of addPanelEntitySkeletonWidths; track width) {
                          <div class="entity-item d-flex align-items-center p-2 border-bottom"
                            >
                            <ngx-skeleton-loader animation="progress" appearance="circle"
                              [theme]="{ width: '18px', height: '18px', margin: '0 8px 0 0' }">
                            </ngx-skeleton-loader>
                            <ngx-skeleton-loader animation="progress"
                              [theme]="{ width: width, height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
                            </ngx-skeleton-loader>
                          </div>
                        }
                      </div>
                      <div
                        class="add-access-footer border-top d-flex align-items-center justify-content-between px-3 py-2">
                        <ngx-skeleton-loader animation="progress"
                          [theme]="{ width: '78px', height: '12px', 'border-radius': '8px', 'margin-bottom': '0' }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader animation="progress"
                          [theme]="{ width: '148px', height: '34px', 'border-radius': '8px', 'margin-bottom': '0' }">
                        </ngx-skeleton-loader>
                      </div>
                    </div>
                  } @else {
                    <!-- Select All header -->
                    @if (activeAccessTab === 'users' ? filteredUsers.length > 0 : filteredGroups.length > 0) {
                      <div class="px-2 py-2 border-bottom d-flex align-items-center select-all-row"
                        >
                        <mat-checkbox color="primary" class="me-2"
                          [checked]="activeAccessTab === 'users' ? isAllUsersSelected : isAllGroupsSelected"
                          (keydown.enter)="onAddPanelSelectAllEnter($event)"
                          (change)="activeAccessTab === 'users' ? toggleAllUsers() : toggleAllGroups()">
                        </mat-checkbox>
                        <span class="fw-semibold small">Select All</span>
                      </div>
                    }
                    <!-- Selectable entity list -->
                    <div class="entity-list overflow-auto" style="max-height: 180px;">
                      @if (activeAccessTab === 'users') {
                        @for (user of filteredUsers; track trackByAvailableUserId($index, user)) {
                          <div class="entity-item d-flex align-items-center p-2 border-bottom cursor-pointer"
                            [attr.tabindex]="checkboxOnlyEntityTabFocus ? null : 0"
                            [attr.role]="checkboxOnlyEntityTabFocus ? null : 'button'"
                            [attr.aria-pressed]="checkboxOnlyEntityTabFocus ? null : selectedUserIds.has(user.id)"
                            [class.entity-item--selected]="selectedUserIds.has(user.id)"
                            (click)="toggleUserSelection(user.id)"
                            (keydown.enter)="onEntityRowEnter('user', user.id)"
                            (keydown.space)="onEntityRowSpace($event, 'user', user.id)">
                            <mat-checkbox color="primary" class="me-2"
                            [class.pe-none]="!checkboxOnlyEntityTabFocus"
                            [checked]="selectedUserIds.has(user.id)"
                            (click)="onEntityCheckboxClick($event)"
                            (keydown.enter)="onEntityCheckboxEnter($event, 'user', user.id)"
                            (change)="onUserCheckboxSelectionChange(user.id, $event.checked)"></mat-checkbox>
                            <div class="d-flex flex-column lh-sm">
                              <span class="small">{{ user.name }}</span>
                            </div>
                          </div>
                        }
                        @if (filteredUsers.length === 0) {
                          <div class="text-center p-3 text-muted small">No
                            users
                            found.
                          </div>
                        }
                      }
                      @if (activeAccessTab === 'groups') {
                        @for (group of filteredGroups; track trackByAvailableGroupId($index, group)) {
                          <div class="entity-item d-flex align-items-center p-2 border-bottom cursor-pointer"
                            [attr.tabindex]="checkboxOnlyEntityTabFocus ? null : 0"
                            [attr.role]="checkboxOnlyEntityTabFocus ? null : 'button'"
                            [attr.aria-pressed]="checkboxOnlyEntityTabFocus ? null : selectedGroupIds.has(group.id)"
                            [class.entity-item--selected]="selectedGroupIds.has(group.id)"
                            (click)="toggleGroupSelection(group.id)"
                            (keydown.enter)="onEntityRowEnter('group', group.id)"
                            (keydown.space)="onEntityRowSpace($event, 'group', group.id)">
                            <mat-checkbox color="primary" class="me-2"
                            [class.pe-none]="!checkboxOnlyEntityTabFocus"
                            [checked]="selectedGroupIds.has(group.id)"
                            (click)="onEntityCheckboxClick($event)"
                            (keydown.enter)="onEntityCheckboxEnter($event, 'group', group.id)"
                            (change)="onGroupCheckboxSelectionChange(group.id, $event.checked)"></mat-checkbox>
                            <span class="small">{{ group.name }}</span>
                          </div>
                        }
                        @if (filteredGroups.length === 0) {
                          <div class="text-center p-3 text-muted small">No
                            groups
                          found.</div>
                        }
                      }
                    </div>
                    <!-- Add Selected footer -->
                    <div
                      class="add-access-footer border-top d-flex align-items-center justify-content-between px-3 py-2">
                      <span class="text-muted small">{{ selectedCount }} selected</span>
                      <button type="button" class="bt-background" mat-raised-button
                        [disabled]="selectedCount === 0" (click)="addSelected()">
                        Add {{ activePermissionTab === 'edit' ? 'Edit' : 'View' }} Access{{ selectedCount >
                        0 ? ' ('
                        +
                        selectedCount + ')' : '' }}
                      </button>
                    </div>
                  }
                </div>
              }
              <!-- Read-only notice -->
              @if (!canModifyAccess) {
                <div class="text-muted text-center small px-2 py-2">
                  <span>You do not have permission to modify access for this service.</span>
                </div>
              }
              <!-- Natural language summary -->
              @if (activeEntryCount > 0) {
                <div class="text-muted small px-2 pb-2" style="font-size: 13px;">
                  @if (activePermissionTab === 'edit' && editTabCount > 0) {
                    {{ editTabCount }} {{ activeAccessTab === 'users' ? (editTabCount === 1 ? 'user' : 'users') :
                    (editTabCount === 1 ? 'group' : 'groups') }} with edit permission.
                  }
                  @if (activePermissionTab === 'view' && viewTabCount > 0) {
                    {{ viewTabCount }} {{ activeAccessTab === 'users' ? (viewTabCount === 1 ? 'user' : 'users') :
                    (viewTabCount === 1 ? 'group' : 'groups') }} with view permission.
                  }
                </div>
              }
              <!-- Select All header for Edit Panel -->
              @if (isEditingEntries && filteredEntries.length > 0 && isAllEntriesSelected !== undefined) {
                <div class="px-2 py-2 border-bottom d-flex align-items-center select-all-row flex-shrink-0"
                  >
                  <mat-checkbox color="primary" class="me-2" [checked]="isAllEntriesSelected"
                    (keydown.enter)="onEntriesSelectAllEnter($event)"
                    (change)="toggleAllEntries()"
                    [disabled]="filteredEntries.length === 1 && filteredEntries[0].permission === 1">
                  </mat-checkbox>
                  <span class="fw-semibold small">Select All</span>
                </div>
              }
              <!-- Entries list -->
              @if (filteredEntries.length > 0) {
                <div class="access-entries-list">
                  @for (entry of filteredEntries; track trackByAccessEntryId($index, entry)) {
                    <div class="access-entry d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
                      [attr.tabindex]="isEditingEntries && entry.permission !== 1 ? 0 : null"
                      [attr.role]="isEditingEntries && entry.permission !== 1 ? 'button' : null"
                      [attr.aria-pressed]="isEditingEntries && entry.permission !== 1 ? selectedEntryIds.has(entry.id) : null"
                      [class.cursor-pointer]="isEditingEntries && entry.permission !== 1"
                      (click)="isEditingEntries && entry.permission !== 1 ? toggleEntrySelection(entry.id) : null"
                        (keydown.enter)="isEditingEntries && entry.permission !== 1 ? toggleEntrySelection(entry.id) : null"
                        (keydown.space)="isEditingEntries && entry.permission !== 1 ? toggleEntrySelection(entry.id) : null; $event.preventDefault()"
                      [class.entity-item--selected]="isEditingEntries && selectedEntryIds.has(entry.id)">
                      <!-- Multi-select checkbox -->
                      @if (isEditingEntries) {
                        <mat-checkbox color="primary" class="me-3 pe-none"
                          [checked]="selectedEntryIds.has(entry.id)" [disabled]="entry.permission === 1">
                        </mat-checkbox>
                      }
                      <div class="entry-left w-100 d-flex align-items-center gap-3">
                        <mat-icon class="entry-icon text-muted material-symbols-outlined">{{ activeAccessTab === 'users' ?
                          'person_outline' :
                        'group' }}</mat-icon>
                        <div class="entry-info lh-sm">
                          <div class="entry-name small">{{ entry.name }}
                            @if (entry.permission === 1) {
                              <span class="badge bg-light text-primary ms-1"
                              >Owner</span>
                            }
                          </div>
                          @if (entry.detail) {
                            <div class="entry-detail text-muted small">{{ entry.detail }}
                            </div>
                          }
                        </div>
                      </div>
                      @if (!isEditingEntries) {
                        <div class="entry-right">
                          <button type="button" mat-icon-button class="btn-delete"
                            (click)="removeAccess(entry); $event.stopPropagation()"
                            [disabled]="entry.permission === 1 || !canModifyAccess">
                            <mat-icon class="material-symbols-outlined">delete_outline</mat-icon>
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                @if (hasActiveNonOwnerEntries || isEditingAccess) {
                  <div class="text-center p-3 text-muted small">
                    No {{ activeAccessTab === 'users' ? 'users' : 'groups' }} with {{ activePermissionTab }}
                    permission.
                  </div>
                }
                @if (!(hasActiveNonOwnerEntries || isEditingAccess)) {
                  <div class="text-center p-4 text-muted small"
                    >
                    No {{ activeAccessTab === 'users' ? 'users' : 'groups' }} found.
                  </div>
                }
              }
              <!-- Bulk action footer -->
              @if (isEditingEntries) {
                <div class="bulk-action-footer d-flex align-items-center justify-content-between px-3 py-2 border rounded mt-3 mb-2"
                  >
                  <span class="text-muted small fw-semibold">{{ selectedEntryCount }} selected</span>
                  <div>
                    <!-- Switch to View: always available when entries are selected -->
                    @if (activePermissionTab === 'edit') {
                      <button type="button" mat-button color="primary" class="me-2"
                        [disabled]="selectedEntryCount === 0"
                        (click)="switchSelectedTo('view')">
                        Switch to View
                      </button>
                    }
                    <!-- Switch to Edit: only enabled when every selected user has Edit entitlement -->
                    @if (activePermissionTab === 'view') {
                      <button type="button" mat-button color="primary" class="me-2"
                            [disabled]="!canSwitchSelectedToEdit" [matTooltip]="!canSwitchSelectedToEdit && selectedEntryCount > 0
                            ? 'One or more selected users do not have Edit-level entitlement and cannot be upgraded to Edit access.'
                            : ''" (click)="switchSelectedTo('edit')">
                        Switch to Edit
                      </button>
                    }
                    <button type="button" mat-button color="warn" [disabled]="selectedEntryCount === 0"
                      (click)="deleteSelected()">
                      Delete
                    </button>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
    }
}
